module.exports = __webpack_public_path__ + "img/anie.5a942ed.webp";